import { createFileRoute } from '@tanstack/react-router'

import { useCreateSettlement } from '@/api/api-mutations'
import { Button } from '@/components/base/button'
import { Drawer } from '@/components/base/drawer'
import { Heading } from '@/components/base/heading'
import { toast } from '@/components/base/toast'
import { FormContainer, FormFieldGroup, useAppForm } from '@/components/form/form'
import { RouteModal, RouteModalFormBlocker, useRouteModal } from '@/components/route-modal'
import { useI18n } from '@/i18n/i18n-react'

export const Route = createFileRoute('/_authenticated/_general/companies/$companyUuid/settlements/create')({
	component: RouteComponent,
	staticData: { crumb: ({ context: { L } }) => L.Settlements.CreateTitle() }
})

function RouteComponent() {
	return (
		<RouteModal asDrawer>
			<NewSettlementForm />
		</RouteModal>
	)
}

function NewSettlementForm() {
	const { L } = useI18n()
	const { handleSuccess } = useRouteModal()
	const { companyUuid } = Route.useParams()

	const createSettlement = useCreateSettlement()

	const form = useAppForm({
		defaultValues: {
			periodStart: 0,
			periodEnd: 0
		},
		onSubmit: async ({ value }) => {
			await createSettlement({
				path: { companyUuid },
				body: {
					periodStart: value.periodStart,
					periodEnd: value.periodEnd
				}
			})
			toast.success(L.Settlements.CreateSuccess())
			handleSuccess()
		}
	})

	return (
		<form.AppForm>
			<RouteModalFormBlocker form={form as any} />
			<Drawer.Header>
				<Drawer.Title asChild>
					<Heading>{L.Settlements.CreateTitle()}</Heading>
				</Drawer.Title>
			</Drawer.Header>
			<Drawer.Body className='flex-1 overflow-auto'>
				<FormContainer>
					<FormFieldGroup>
						<form.AppField
							name='periodStart'
							children={field => <field.DateField label={L.Fields.StartDate()} />}
						/>
					</FormFieldGroup>

					<FormFieldGroup>
						<form.AppField
							name='periodEnd'
							children={field => <field.DateField label={L.Fields.EndDate()} />}
						/>
					</FormFieldGroup>
				</FormContainer>
			</Drawer.Body>
			<Drawer.Footer>
				<div className='flex items-center justify-end gap-x-2'>
					<Drawer.Close asChild>
						<Button variant='secondary' size='small'>
							{L.General.Cancel()}
						</Button>
					</Drawer.Close>
					<form.CreateButton />
				</div>
			</Drawer.Footer>
		</form.AppForm>
	)
}
